import { jsx as _jsx } from "react/jsx-runtime";
import { ModalCloseButton as ChakraModalCloseButton, } from '@chakra-ui/react';
import { BxX } from '../icons';
export const ModalCloseButton = ({ children = _jsx(BxX, { fontSize: "2rem" }), ...props }) => {
    return (_jsx(ChakraModalCloseButton, { variant: "clear", colorScheme: "neutral", ...props, children: children }));
};
